<template lang="pug">
.batch-list
  //- サイドメニュー部
  side-menu.batch-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .batch-list__content
    breadcrumb-list.batch-list__content__breadcrumb(:breadcrumbs='breadcrumbs')

    .batch-list__content__body
      .batch-list__content__body__main
        .batch-list__content__body__main__action
          .batch-list__content__body__main__action__label
            slot(name='batchLabel')
          button-primary.batch-list__content__body__main__action__button(@click='batchButtonEvent')
            slot(name='batchButtonText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import ButtonPrimary from '@/components/molecules/manager/ButtonPrimary.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'

/**
 * バッチ一覧画面
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    ButtonPrimary,
  },
})
export default class BatchList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // バッチボタン押下時のイベント
  @Prop()
  batchButtonEvent!: Function
}
</script>

<style lang="stylus" scoped>
.batch-list
  display flex
  width 100%
  height 100%

  &__content
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 20px
    overflow-y auto

    &__body
      display flex
      flex-direction column

      &__main
        width 100%
        min-height 500px
        display flex
        flex-direction column
        border-radius 15px
        background var(--color-manager-list__background)
        box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)

        &__action
          display flex
          align-items center
          padding 20px 30px
          gap 10px

          &__button
            padding 10px 20px
</style>
